import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ILegalEntity } from '../types/legalEntity';

@Injectable()
export class LegalEntityService {
  legalEntity = new BehaviorSubject<boolean>(false);
  legalEntityMobileLabel = new BehaviorSubject<string>('');
  searchPlaceholder = new BehaviorSubject<string>('');
  isLoading = new BehaviorSubject<boolean>(false);
  searchTermChange = new EventEmitter<string>();
  message = new BehaviorSubject<string>('');
  legalEntityChange = new EventEmitter<number>();
  legalEntitiesList = new BehaviorSubject<ILegalEntity[]>([]);
  legalEntityActive = new BehaviorSubject<ILegalEntity>(null);
  legalEntityReachedEnd = new EventEmitter<void>();
  isModalOpen = new EventEmitter<boolean>(false);

  constructor() {}
}
